import createIcon from '../../createIcon';

/**
 * @component @name PowerInput
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi41IDlWMTFIMjEuNVY5SDIuNVpNMi41IDE1SDcuNVYxM0gyLjVWMTVaTTkuNSAxNUgxNC41VjEzSDkuNVYxNVpNMTYuNSAxNUgyMS41VjEzSDE2LjVWMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PowerInput = createIcon('PowerInput', [
  [
    'path',
    {
      d: 'M2.5 9V11H21.5V9H2.5ZM2.5 15H7.5V13H2.5V15ZM9.5 15H14.5V13H9.5V15ZM16.5 15H21.5V13H16.5V15Z',
      key: 'h43qvo',
    },
  ],
]);

export default PowerInput;
